import React, { createContext, useReducer } from "react";
import { DataManagerReducer } from "../reducer/DataManagerReducer";

export const DataManagerContext = createContext();

export const DataManagerContextProvider = (props) => {
  const [myData, dispatch] = useReducer(DataManagerReducer, {}, () => {
    // const localData = localStorage.getItem("user");
    // return localData ? JSON.parse(localData) : [];
    return {}
  });

  const setDataManager = (data) => {
    dispatch({
      type: "DATA_MANAGE",
      payload: data,
    });
  };

  //   useEffect(() => {
  //     localStorage.setItem("user", JSON.stringify(user));
  //   }, [loginUser]);
  return (
    <DataManagerContext.Provider value={{ setDataManager, myData }}>
      {props.children}
    </DataManagerContext.Provider>
  );
};

export default DataManagerContextProvider;
